import Profile from './clinicProfile';

class ClinicAction {
    /**
     * Clinic Action Class
     */
    constructor(axios) {
        this.http = axios;
        this._profile = new Profile(axios);
    }


    /**
     * Clinic Profile Service
     */
    get profile() {
        return this._profile;
    }

    /**
     * Create one clinic
     * @param {Object} data
     * @returns Promise object
     */
    create(data) {
        return this.http.post("/api/clinicbase/create.php", data);
    };
    /**
     * Read all clinics by id
     * @param {string | number} id clinic id
     * @returns Promise object
     */
    read(id) {
        return this.http.get(`/api/clinicbase/read_by_index.php?id=${id}`);
    };
    /**
     * Read one clinic
     * @param {string | number} id clinic id
     * @returns Promise object
     */
    readOne(id) {
        return Promise.reject('NOT_IMPLEMENTED');
    };
    /**
     * Update one clinic
     * @param {Object} data
     * @returns Promise object
     */
    update(data) {
        return this.http.post("/api/clinicbase/update.php", data);
    };
    /**
     * Delete one clinic
     * @param {string | number} id clinic id
     * @returns Promise object
     */
    delete(id) {
        return Promise.reject('NOT_IMPLEMENTED');
    };
    /**
     * Search clinic by name
     * @param {String} value clinic name
     * @returns Promise object
     */
    search(clinicName) {
        return this.http.get(`/api/clinicbase/read_by_index.php?id=${clinicName}`);
    };
}

export default ClinicAction;
